import { sendGA4Event, getItemLocation } from '@utils/analytics';

export const ga4ClickHandler = () => {
  document.addEventListener('click', (event) => {
    const target = event?.target as Element;
    const element = target?.closest('[data-ga4-event-onclick]');

    if (!element) return;

    const label = element.getAttribute('data-ga4-label');
    const state = element.getAttribute('data-ga4-state');
    const type = element.getAttribute('data-ga4-type');
    const itemLocation = element.getAttribute('data-ga4-path');

    const params = {
      item_label: label,
      item_location: getItemLocation(itemLocation),
      state,
      type,
    };

    const filteredParams = Object.keys(params).reduce((acc, key) => {
      if (params[key]) {
        acc[key] = params[key];
      }
      return acc;
    }, {});

    sendGA4Event('click', filteredParams);
  });
};
